export const fetchDestinationName = (value, warehouseList) => {
  if (warehouseList && value) {
    let warehouse = warehouseList[value];
    return warehouse.warehouseName
      .replace("Intellihealth Solutions Private Limited - ", "")
      .replace(" Hub", "");
  }
};
